<template>
  <component :is="computedTag"
             class="nav-link d-flex"
             :to="href"
             :class="[{active: active}, activeVariant]"
             :data-location="activeLocation"
             :replace="replace"
             aria-current="page"
             @click="$emit('click')"
  >
    <slot/>
  </component>
</template>

<script>

export default {
  name: 'VNavLink',
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    href: {
      type: [String, Object],
      required: false,
    },
    replace: Boolean,
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    activeLocation: {
      type: String,
      required: false,
      default: 'right',
    },
    activeColor: {
      type: String,
      required: false,
    },
  },
  computed: {
    computedTag() {
      return this.href ? 'router-link' : this.tag;
    },
    activeVariant() {
      return this.activeColor ? `active-${this.activeColor}` : '';
    },
  },
};
</script>

<style lang="scss">
@import "VNavLink";
</style>
